import type { Catalogue } from "../i18n";

export const BR: Catalogue = {
  "failed": "c'hwitet",
  "saving": "o enrollañ",
  "waiting": "o c'hortoz",
  "today": "hiziv",
  "yesterday": "dec'h",
  "{days}d": "{days} d",
  "{weeks}w": "{weeks} sizh",
  "unlabeled": "hep anv",
  "untagged": "hep tag",
  "loading more": "o kargañ ouzhpenn",
  "that's all {count}": "echu eo, {count}",
  "shuffled": "meskaet",
  "nothing to show": "netra da ziskouez",
  "chi is looking again": "chi a sell en-dro",
  "chi is looking at this one next": "chi a sello ouzh homañ da-heul",
  "could not index that ref": "n'eo ket bet posupl kaout meneger evit ar ref-se",
  "details": "munudoù",
  "clips are not described, write your own": "ar c'hlipoù n'int ket diskrivet, skrivit hoc'h hini",
  "chi left this one ({reason}), write your own": "chi he deus lezet homañ ({reason}), skrivit hoc'h hini",
  "chi is looking at this…": "chi a sell ouzh homañ…",
  "not described yet, write your own or tap spark": "n'eo ket diskrivet c'hoazh, skrivit hoc'h hini pe stokit war spark",
  "saved": "enrollet",
  "could not save the description": "n'eo ket bet posupl enrollañ an diskrivadur",
  "chi skips clips": "chi a lez ar c'hlipoù",
  "described": "diskrivet",
  "chi is looking": "chi a sell",
  "skipped": "lezet",
  "waiting on chi": "o c'hortoz chi",
  "tagging {done}/{total} · {left} left": "o tagañ {done}/{total} · {left} chom",
  "tagged {done}/{total} · {left} left": "tagaet {done}/{total} · {left} chom",
  "all {total} tagged": "an {total} holl tagaet",
  "{shown} of {total}": "{shown} diwar {total}",
  "{count} adding": "{count} o ouzhpennañ",
  "{count} failed": "{count} c'hwitet",
  "{count} to describe": "{count} da zisklêriañ",
  "busy": "ac'hubet",
  "tag": "tag",
  "tap + to add pictures, drop files here, or use + ref in chrome": "stokit war + evit ouzhpennañ skeudennoù, lakait restroù amañ, pe implijit + ref e chrome",
  "every ref already has your note": "bep ref en deus dija ho notenn",
  "nothing matches": "netra ne glot",
  "could not load references": "n'eo ket bet posupl kargañ ar c'hrefoù",
  "video": "video",
  "all described": "an holl diskrivet",
  "could not read that file": "n'eo ket bet posupl lenn ar restr-se",
  "nothing usable there": "netra implijadus eno",
  "adding {count}": "o ouzhpennañ {count}",
  "could not import that file": "n'eo ket bet posupl enporzhiañ ar restr-se",
  "showing {tag}": "o tiskouez {tag}",
  "chi is tagging {count} refs": "chi a dag {count} ref",
  "every ref is tagged": "bep ref zo tagaet",
  "could not start tagging": "n'eo ket bet posupl kregiñ da dagañ",
  "delete this reference?": "dilemel ar ref-mañ?",
  "ref saved": "ref enrollet",
  "ref save failed": "c'hwitet eo bet enrollañ ar ref",
  "tagging done": "echu eo an tagañ",
  "mode": "mod",
  "tools": "binvioù",
  "Tools": "Binvioù",
  "Talk to Chi": "Komz ouzh Chi",
  "mode tuner, drag or tap a station": "tunerez ar mod, tennit pe stokit war ur gar",
  "Tool": "Binvi",
  "Chi · direct line": "Chi · linenn war-eeun",
  "{name}'s {what} · read only": "{what} {name} · lenn hepken",
  "could not open a print sheet": "n'eo ket bet posupl digeriñ ur follenn voullañ",
  "never": "morse",
  "could not shrink that picture": "n'eo ket bet posupl bihanaat ar skeudenn-se",
  "could not read that picture": "n'eo ket bet posupl lenn ar skeudenn-se",
  "chix is processing": "chix a labour",
  "What should I work on next?": "Petra a rafen da gentañ?",
  "nothing yet": "netra c'hoazh",
  "where it came from": "a-belec'h e teu",
  "rent, phone…": "lojeiz, pellgomz…",
  "what was it": "petra e oa",
  "mine": "ma hini",
  "{name}'s": "a {name}",
  "added to {name}'s budget": "ouzhpennet da budjed {name}",
  "added to your budget": "ouzhpennet d'ho puzhed",
  "couldn't add that": "n'eo ket bet posupl ouzhpennañ an dra-se",
  "login with discord": "kevreañ gant discord",
  "minipi #{id}": "minipi #{id}",
  "a minipi": "ur minipi",
  "{who} says": "{who} a lavar",
  "{who} · art tip": "{who} · tun arz",
  "pings": "pingoù",
  "Late shift, {name}.": "Noz-vat, {name}.",
  "Morning, {name}.": "Mat an deiz, {name}.",
  "Ready when you are, {name}.": "Prest on pa vo mat ganeoc'h, {name}.",
  "Evening, {name}.": "Mat an noz, {name}.",
  "signal": "sinal",
  "sweet": "sukr",
  "edge": "riblenn",
  "dark fog, film grain and chi's cyan": "latar teñval, greun film ha cyan chi",
  "pale daytime fog, ink and deep teal": "latar sklaer deiz, ankr ha teal don",
  "silent hill ash and an orange coal": "ludu Silent Hill ha glaou orañjez",
  "deep water, teal fog, a sonar ping": "dour don, latar teal, ur ping sonar",
  "rose paper and a hot pink signal": "paper rozennek ha sinal pink tomm",
  "peach cream and a coral signal": "dienn pesk ha sinal koral",
  "mint milk with strawberry pink": "laezh menta gant pink sivi",
  "magical girl night, violet fog, bubblegum pink": "noz merc'h hudus, latar violet, pink chewing-gum",
  "midnight sky in periwinkle and pink": "oabl hanternoz e periwinkle ha pink",
  "the otherworld: rust black and blood red": "an trede bed: du rouzh ha ruz gwad",
  "night city chrome, warning yellow, red glitch": "kromiom kêr-nozvezh, melen kemenn, glitch ruz",
  "bruise purple fog and acid lime": "latar limestra limestra violet ha limon trenk",
  "pure black and white, no mercy": "du ha gwenn pur, hep truez",
  "green crt, memory card manager at 2am": "CRT glas, merour kartenn-vemor da 2 eur war-lerc'h kreisteiz",
  "amber crt terminal, warm glow": "termenell CRT ambr, lufr tomm",
  "cream sketch paper and flipnote orange": "paper tresañ crem ha orañjez flipnote",
  "grey console, blue memory card screen": "konsolenn c'hris, skramm kartenn-vemor glas",
  "four shades of handheld green": "pevar nuañs a wer ar c'harr-skor",
  "none": "hini ebet",
  "scanlines": "linennoù skanañ",
  "grid": "gwriziennoù",
  "dots": "pikoù",
  "notebook": "kaier",
  "checker": "damier",
  "crosshair": "kroaz-vir",
  "sparkles": "lufradoù",
  "hazard": "riskl",
  "starry sky": "oabl steredennek",
  "falling leaves": "delioù o kouezhañ",
  "sakura petals": "bleunioù sakura",
  "snow": "erc'h",
  "rain": "glav",
  "fireflies": "tan-gwenn",
  "moves gently, stays still with calm motion": "fiñv dous, chom difiñv gant fiñv sioul",
  "pattern on": "patrom war",
  "theme on": "tem war",
  "saved, type to replace": "enrollet, skrivit evit erlec'hiañ",
  "not set": "n'eo ket lakaet",
  "token copied": "ar jedon zo bet eilet",
  "make a new extension token? the old one stops working until you paste the new one in": "krouiñ ur jedon ekstent nevez? ar hini kozh a baouez da labourat betek ma lakaot an hini nevez",
  "new token made": "jedon nevez krouet",
  "log out of chix on every device?": "dilugañ diouzh chix war an holl aveadurioù?",
  "$ dollar": "$ dollar",
  "£ pound": "£ lur",
  "C$ canadian": "C$ kanadat",
  "A$ australian": "A$ aostralian",
  "CHF swiss franc": "CHF lur-gouez ar Suis",
  "talking to plane": "o komz gant plane",
  "connected to {workspace}, now pick your boards": "kevreet ouzh {workspace}, dibabit ho taolennoù bremañ",
  "open plane": "digeriñ plane",
  "in safari, create an api token in profile settings, paste it below, then save": "e safari, krouit ur jedon api e arventennoù ar profil, pegit anezhañ dindan, ha enrollit",
  "couldn't do that": "n'eo ket bet posupl ober an dra-se",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google en deus nac'het alc'hwez ar gartenn. gwiriit ez eo aotreet war al lec'hienn-mañ ha ma'z eo enaouet maps javascript api",
  "the map needs a key to draw, searches and routes still work below": "ret eo kaout un alc'hwez evit tresañ ar gartenn, ar sellerezh hag an hentoù a c'hell labourat dindan",
  "the map couldn't load. searches and routes still work below": "n'eo ket bet posupl kargañ ar gartenn. ar sellerezh hag an hentoù a c'hell labourat dindan",
  "you": "c'hwi",
  "new pin": "pin nevez",
  "open now": "digor bremañ",
  "closed now": "serret bremañ",
  "new": "nevez",
  "{rating} from 1 review": "{rating} diwar 1 sell",
  "{rating} from {count} reviews": "{rating} diwar {count} sell",
  "no reviews yet": "hep sell c'hoazh",
  "no parking info": "hep titouroù parklec'h",
  "no parking listed": "parklec'h ebet roll",
  "{place} is stop {letter}": "{place} a zo ar chom {letter}",
  "save": "enrollañ",
  "looking…": "o klask…",
  "nothing found there. try further out or other words": "n'eus bet kavet netra aze. klaskit pelloc'h pe gant gerioù all",
  "pick something to look for, or search above": "dibabit un dra da glask, pe klaskit a-us",
  "{what} within {distance} of {place}": "{what} e-barzh {distance} diouzh {place}",
  "around {place}": "tro-dro da {place}",
  "ten stops is the most": "dek chom a-walc'h",
  "taken out of saved": "tennet diwar ar re enrollet",
  "remove {name}?": "dilemel {name}?",
  "nothing saved yet": "netra enrollet c'hoazh",
  "tap the map": "stokit war ar gartenn",
  "drop a pin": "lakaat ur pin",
  "edit {name}": "kemmañ {name}",
  "save pin": "enrollañ ar pin",
  "my pin": "ma fin",
  "pinned": "pinet",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "al lec'hioù, ar sellouedoù, ar parklec'hioù hag an hentoù a zeu eus google maps. un alc'hwez eus ho kont google cloud zo ret, google a ro un darn digoust bep miz",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "n'en deus fractal ouzhpennet alc'hwez google maps c'hoazh, setu n'hall ket ar gartenn klask netra",
  "within {distance}": "e-barzh {distance}",
  "this area": "an takad-mañ",
  "couldn't find where you are, staying around {place}": "n'eo ket bet posupl kavout al lec'h m'emaoc'h, chom a rin tro-dro da {place}",
  "cyan": "cyan",
  "violet": "violet",
  "amber": "ambr",
  "green": "glas",
  "red": "ruz",
  "tap the map where the pin goes": "stokit war ar gartenn el lec'h ma ranker lakaat ar pin",
  "couldn't find where you are": "n'eo ket bet posupl kavout al lec'h m'emaoc'h",
  "take this pin off the map?": "tennañ ar pin-mañ diwar ar gartenn?",
  "where i am": "el lec'h ma'z on",
  "home ({place})": "ti ({place})",
  "name this route": "envel an hent-mañ",
  "{from} to {to}": "{from} da {to}",
  "route saved": "hent enrollet",
  "food": "boued",
  "pubs and bars": "tavarnioù ha barioù",
  "takeaway": "da gemer gant-hoc'h",
  "shops": "stalioù",
  "fuel": "tanwezh",
  "parking": "parklec'h",
  "pharmacy": "apotikerezh",
  "parks": "parkoù",
  "things to see": "traoù da welet",
  "cinema": "sinema",
  "ev charging": "karg kirri tredan",
  "drive": "gant ur c'harr",
  "walk": "war-droad",
  "cycle": "gant ur velo",
  "bus/train": "bus/tren",
  "{amount} a month": "{amount} bep miz",
  "by {date}": "a-raok {date}",
  "monthly, stopped {date}": "bep miz, paouezet {date}",
  "monthly from {date}": "bep miz adalek {date}",
  "on {date}": "d'an {date}",
  "added by you": "ouzhpennet ganeoc'h",
  "added by {name}": "ouzhpennet gant {name}",
  "{done} paid of {total} · {left} left": "{done} paeet diwar {total} · {left} chom",
  "paid off · {total}": "paeet penn-da-benn · {total}",
  "{done} saved of {total} · {left} to go": "{done} lakaet a-gostez diwar {total} · {left} da vont",
  "reached · {done}": "tizhet · {done}",
  "in": "ebarzh",
  "bill": "fakturenn",
  "cost": "koust",
  "debt": "dle",
  "goal": "pal",
  "remove {name}? its history goes too": "dilemel {name}? mont a ra e istor ivez",
  "restart": "adkregiñ",
  "stop": "paouez",
  "paid": "paeet",
  "payment logged": "paeamant enrollet",
  "saved toward it": "lakaet a-gostez evitañ",
  "took back the last one": "an hini diwezhañ zo bet distroet",
  "{amount} left": "{amount} chom",
  "{amount} saved": "{amount} lakaet a-gostez",
  "out": "er-maez",
  "no monthly bills yet": "fakturenn viziek ebet c'hoazh",
  "owe": "dleout",
  "{percent}% of {total}": "{percent}% eus {total}",
  "{amount} this month": "{amount} er miz-mañ",
  "owed in total": "dleet e-bezh",
  "target": "pal",
  "a month (optional)": "bep miz (diret)",
  "how much comes in": "pegement a zeu e-barzh",
  "how much": "pegement",
  "by": "a-raok",
  "since": "abaoe",
  "from": "eus",
  "on": "d'an",
  "where it comes from": "a-belec'h e teu",
  "rent, phone, adobe…": "lojeiz, pellgomz, adobe…",
  "what you bought": "ar pezh hoc'h eus prenet",
  "who or what you owe": "da piv pe da betra e tleit",
  "what you're saving for": "evit petra emaoc'h o tec'hel",
  "add": "ouzhpennañ",
  "add to the budget": "ouzhpennañ d'ar budjed",
  "added": "ouzhpennet",
  "couldn't save that": "n'eo ket bet posupl enrollañ an dra-se",
  "due: {title}": "d'ar: {title}",
  "unexpected \"{char}\"": "\"{char}\" dic'hortoz",
  "missing )": ") o vank",
  "expected a number": "niver gortozet",
  "that goes to infinity": "mont a ra da anvevenn",
  "not set, add it in setup": "n'eo ket lakaet, ouzhpennit en arventennoù",
  "{spent} of {budget} for tagging": "{spent} diwar {budget} evit an tagañ",
  "no cap on tagging": "bevenn ebet war an tagañ",
  "{count} refs waiting since {time}": "{count} ref o c'hortoz abaoe {time}",
  "none running": "hini ebet o labourat",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} galv · {input} ebarzh · {cached} er c'hache · {output} er-maez",
  "nothing yet for {month}": "netra c'hoazh evit {month}",
  "{calls} calls": "{calls} galv",
  "split starts with the next answer": "ar rannadur a grog gant ar respont a zeu",
  "could not read claude usage": "n'eo ket bet posupl lenn implij claude",
  "all": "an holl",
  "start {name}?": "loc'hañ {name}?",
  "starting {name}...": "o loc'hañ {name}...",
  "{name} start sent": "goulenn loc'hañ {name} kaset",
  "stop {name}?": "paouez {name}?",
  "stopping {name}...": "o paouez {name}...",
  "{name} stop sent": "goulenn paouez {name} kaset",
  "restart {name}?": "adloc'hañ {name}?",
  "restarting {name}...": "o adloc'hañ {name}...",
  "{name} restart sent": "goulenn adloc'hañ {name} kaset",
  "running": "o labourat",
  "stopped": "paouezet",
  "crash looping": "en un dro-gelc'h fall",
  "starting": "o loc'hañ",
  "up {time}": "war-wel abaoe {time}",
  "{count} restarts": "{count} adloc'hadenn",
  "{name} logs": "marilhoù {name}",
  "loading...": "o kargañ...",
  "{used} of {total}": "{used} diwar {total}",
  "could not reach the server: {error}": "n'eo ket bet posupl tizhout ar servijer: {error}",
  "validating caddy...": "o wiriekaat caddy...",
  "caddy reloaded": "caddy adkarget",
  "{label}, one per line": "{label}, unan dre linenn",
  "change picture": "kemmañ ar skeudenn",
  "all {n}": "an holl {n}",
  "unsorted": "didezet",
  "under a cent": "dindan ur c'hant",
  "chi looking {done}/{total}": "chi a sell {done}/{total}",
  "chi look {done}/{total}": "chi a sell {done}/{total}",
  "chi looked": "chi he deus selet",
  "chi has looked at every character picture": "chi he deus selet holl skeudennoù ar c'harzhoù",
  "{n} more wait for another press.": "{n} all a c'hortoz ur wask all.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi he deus selet {done} skeudenn diwar {total}. selet an {count} da-heul evit tro {price}? tremen a ra dre ar bern hanter-priz, setu e c'hall padout pell.",
  "chi is looking at {count} pictures": "chi a sell ouzh {count} skeudenn",
  "could not start chi": "n'eo ket bet posupl loc'hañ chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "chi a sell ouzh 1 skeudenn eus {name} n'he deus ket gwelet c'hoazh, tro {price}?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "chi a sell ouzh {count} skeudenn eus {name} n'he deus ket gwelet c'hoazh, tro {price}?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi he deus gwelet an holl {total} skeudenn eus {name}. selet anezho en-dro adalek an deroù, tro {price}?",
  "chi is looking at {name}": "chi a sell ouzh {name}",
  "picture {n}": "skeudenn {n}",
  "adding 1 picture…": "o ouzhpennañ 1 skeudenn…",
  "adding {n} pictures…": "o ouzhpennañ {n} skeudenn…",
  "picture added": "skeudenn ouzhpennet",
  "{n} pictures added": "{n} skeudenn ouzhpennet",
  "could not add the picture": "n'eo ket bet posupl ouzhpennañ ar skeudenn",
  "take this picture off the character?": "tennañ ar skeudenn-mañ diwar ar c'harzh?",
  "picture removed": "skeudenn dilamet",
  "could not remove the picture": "n'eo ket bet posupl dilemel ar skeudenn",
  "sheet picture changed": "skeudenn ar follenn kemmet",
  "could not change the picture": "n'eo ket bet posupl kemmañ ar skeudenn",
  "fetching characters from {source}…": "o tont da gaout ar c'harzhoù eus {source}…",
  "{n} found": "{n} kavet",
  "{n} added": "{n} ouzhpennet",
  "{n} updated": "{n} nevesaet",
  "{n} duplicates merged": "{n} eilad kenunanet",
  "{n} failed": "{n} c'hwitet",
  "{source} import failed": "c'hwitet eo bet enporzh {source}",
  "aka {names}": "aka {names}",
  "{n} pictures": "{n} skeudenn",
  "merge into {name}": "kenunaniñ e {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "kenunaniñ {other} e {name}? follenn {other} a ya kuit hag e skeudennoù a ya da {name}.",
  "{other} merged into {name}": "{other} kenunanet e {name}",
  "the sheet": "ar follenn",
  "could not merge": "n'eo ket bet posupl kenunaniñ",
  "character saved": "karzh enrollet",
  "could not save": "n'eo ket bet posupl enrollañ",
  "delete {name}?": "dilemel {name}?",
  "1 block today": "1 bloc'h hiziv",
  "{n} blocks today": "{n} bloc'h hiziv",
  "resume": "kenderc'hel",
  "back to drawing": "distro da dresañ",
  "break time, stretch your hand": "amzer ehanañ, astennit ho taol",
  "focus block started": "bloc'h fokus loc'het",
  "take a break": "kemer un ehan",
  "type minutes, like 40 or 1h30": "skrivit ar vunutennoù, evel 40 pe 1h30",
  "drop this picture": "dilemel ar skeudenn-mañ",
  "toss {hex}?": "teuler {hex}?",
  "copied {hex}": "{hex} eilet",
  "prompt copied": "prompt eilet",
  "commissions": "urzhioù",
  "no commissions": "urzh ebet",
  "comms money": "arc'hant an urzhioù",
  "{n} paid": "{n} paeet",
  "{n} others": "{n} all",
  "nothing paid yet": "netra paeet c'hoazh",
  "that task is done or gone": "echu eo an trevell-se pe aet eo kuit",
  "unlink {title}": "dilemel al liamm {title}",
  "no task matches": "trevell ebet ne glot",
  "no open tasks. add one in tasks first": "trevell digor ebet. ouzhpennit unan e trevelloù da gentañ",
  "for {client}": "evit {client}",
  "paid {day}": "paeet d'an {day}",
  "due {date}": "d'an {date}",
  "commission saved": "urzh enrollet",
  "commission added": "urzh ouzhpennet",
  "break": "ehan",
  "unknown": "dianav",
  "fapped {n} times": "fapet {n} gwech",
  "no doodles match": "doodle ebet ne glot",
  "could not load the doodles": "n'eo ket bet posupl kargañ an doodle",
  "no picture on the clipboard": "skeudenn ebet er golver-glip",
  "pick a picture": "dibabit ur skeudenn",
  "you can look at the doodles, not add them": "gallout a rit sellout ouzh an doodle, met n'hallit ket o ouzhpennañ",
  "adding the doodle": "o ouzhpennañ an doodle",
  "adding {n} of {total}": "o ouzhpennañ {n} diwar {total}",
  "{n} doodles added": "{n} doodle ouzhpennet",
  "could not add that": "n'eo ket bet posupl ouzhpennañ an dra-se",
  "press ctrl+v or ⌘v to paste": "pouezit war ctrl+v pe ⌘v evit pegañ",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "n'eo ket bet posupl lenn ar golver-glip, esaeit ctrl+v pe ⌘v",
  "gone": "aet kuit",
  "remove {name}": "dilemel {name}",
  "new doodle": "doodle nevez",
  "doodle saved": "doodle enrollet",
  "delete this doodle?": "dilemel an doodle-mañ?",
  "could not delete": "n'eo ket bet posupl dilemel",
  "by {name}": "gant {name}",
  "one a day per doodle, come back tomorrow": "unan bemdez dre doodle, deuit en-dro warc'hoazh",
  "today ✓ {n}": "hiziv ✓ {n}",
  "fapped {n}×": "fapet {n}×",
  "you {n}": "c'hwi {n}",
  "could not count that": "n'eo ket bet posupl kontañ an dra-se",
  "random full body poses from the pocketbase library": "poz korf-a-bezh dre zegouezh eus levraoueg pocketbase",
  "{n} refs in the pool": "{n} ref er pod",
  "no refs match yet": "ref ebet ne glot c'hoazh",
  "could not fetch poses": "n'eo ket bet posupl kaout pozioù",
  "play": "c'hoari",
  "no poses to draw from": "poz ebet da dresañ",
  "{n} poses done, nice": "{n} poz graet, brav",
  "{n} answered today": "{n} respontet hiziv",
  "{n} day streak": "{n} devezh a-heul",
  "nothing due right now, {n} learning cards come back in {minutes}m": "netra da zeskiñ bremañ, {n} kartenn o teskiñ a zeu en-dro a-benn {minutes} m",
  "today's cards are done, see you tomorrow": "kartennoù hiziv zo graet, betek warc'hoazh",
  "no cards to study, switch a deck on below": "kartenn ebet da studiañ, enaouit ur pakad amañ dindan",
  "{seen} of {total} seen · {solid} solid": "{seen} diwar {total} gwelet · {solid} start",
  "study {deck}": "studiañ {deck}",
  "could not load the deck": "n'eo ket bet posupl kargañ ar pakad",
  "could not save that answer": "n'eo ket bet posupl enrollañ ar respont-se",
  "could not save the deck setup": "n'eo ket bet posupl enrollañ stumm ar pakad",
  "basics": "diazez",
  "favourites": "a blij",
  "likes and goals": "karet ha pal",
  "looks": "neuz",
  "identity": "identelezh",
  "sexuality": "gwenerezh",
  "story": "istor",
  "for chi": "evit chi",
  "orientation": "kenliesk",
  "trivia": "traoù dibar",
  "created by": "krouet gant",
  "world": "bed",
  "location": "lec'h",
  "race": "ethnek",
  "occupation": "micher",
  "gender": "reizh",
  "height": "uhelder",
  "favourite food": "boued karet",
  "smell": "c'hwezh",
  "pet peeve": "dra displijus",
  "likes": "a blij dezhañ",
  "dislikes": "n'eo ket plijet",
  "look in short": "neuz e berr",
  "body": "korf",
  "clothes": "dilhad",
  "visual features": "doareoù gwelet",
  "speaking": "komz",
  "personality": "personelezh",
  "relationships": "darempredoù",
  "items": "traoù",
  "skills": "barregezhioù",
  "preferences": "dibaboù",
  "fetishes": "fetishoù",
  "sexual trivia": "traoù dibar gwenerezh",
  "rpg sheet": "follenn rpg",
  "fractal's notes for chi": "notennoù fractal evit chi",
  "sees your {kinds}": "a wel ho {kinds}",
  "sees nothing of yours": "ne wel netra ac'hanoc'h",
  "{line}, adds to your {kinds}": "{line}, a ouzhpenn d'ho {kinds}",
  "{name} can add to your {kind}": "{name} a c'hell ouzhpennañ d'ho {kind}",
  "{name} can only read your {kind}": "{name} a c'hell lenn hepken ho {kind}",
  "{name} can see your {kind}": "{name} a c'hell gwelet ho {kind}",
  "{kind} hidden from {name}": "{kind} kuzhet diouzh {name}",
  "{name} can see everything you can share": "{name} a c'hell gwelet pep tra a c'helloc'h rannañ",
  "{name} sees nothing of yours now": "{name} ne wel netra ac'hanoc'h bremañ",
  "share {kind} with {name}": "rannañ {kind} gant {name}",
  "you don't have notes, pings or anything else to share yet": "n'hoc'h eus notenn, ping pe netra all da rannañ c'hoazh",
  "share all": "rannañ pep tra",
  "share none": "na rannañ netra",
  "nobody else is in chix yet": "den all ebet e chix c'hoazh",
  "shares their {kinds}": "a rann e {kinds}",
  "Calendar events": "Darvoudoù ar bloaz",
  "Places and routes": "Lec'hioù hag hentoù",
  "your sticky notes": "ho notennoù pegus",
  "reminders, alarms and timers": "kemennadennoù, alarmoù ha minutennerioù",
  "your own events on the month": "ho darvoudoù deoc'h-c'hwi er miz",
  "plane and chix bot": "plane ha chix bot",
  "clients, prices, status, linked tasks and money stats": "prenerien, prizioù, statud, trevelloù liammet ha stadegoù arc'hant",
  "bills, costs, debts and goals": "fakturennoù, koustoù, dleoù ha palioù",
  "what you keep up and your streaks": "ar pezh a dalc'hit ha ho renkadoù",
  "spots and routes you saved on the map": "lec'hioù hag hentoù enrollet war ar gartenn",
  "Can add to it": "Gall a ra ouzhpennañ",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "fakturennoù, koustoù, arc'hant o tont ha paeamantoù, gant o anv warno. n'hallont kemmañ nemet ar pezh o deus ouzhpennet",
  "off": "distaget",
  "{on} of {total} on · chi {spent} of {cap}": "{on} diwar {total} enaouet · chi {spent} diwar {cap}",
  "{on} of {total} on · chi {spent}": "{on} diwar {total} enaouet · chi {spent}",
  "{feature} off for {name}": "{feature} distaget evit {name}",
  "{name} can view {feature}": "{name} a c'hell gwelet {feature}",
  "{name} can edit {feature}": "{name} a c'hell kemmañ {feature}",
  "{feature} for {name}": "{feature} evit {name}",
  "monthly chi cap, usd": "bevenn chi bep miz, usd",
  "{name}'s chi stops at {amount} a month": "chi {name} a baouez e {amount} bep miz",
  "no cap for {name}": "bevenn ebet evit {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} dreist {count} respont er miz-mañ. 0 a dalv bevenn ebet",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "dilemel {name}? dilugañ a raio. e notennoù ha kaozeadennoù a chomo war ar servijer ma lakait anezhañ en-dro",
  "{name} removed": "{name} dilamet",
  "just you for now": "c'hwi hepken evit bremañ",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} a c'hell kevreañ bremañ. krogañ a ra gant chi, notennoù, pingoù ha ritualoù",
  "Calendar and pings": "Deiziadur ha pingoù",
  "Chi speaker": "Komzer chi",
  "Discord messages": "Kemennadennoù Discord",
  "Keys and server setup": "Alc'hwezioù ha kefluniadur ar servijer",
  "their own chat and memory, on your claude account": "e gaozeadennoù hag e vemor, war ho kont claude",
  "the shared ref library": "al levraoueg ref rannet",
  "the shared oc sheets": "follennoù oc rannet",
  "their own": "e hini",
  "plane and chix bot, their own": "plane ha chix bot, e hini",
  "timer, palette, prompts, comms and their money stats": "minutenner, palette, prompts, comms ha stadegoù arc'hant",
  "their own bills, costs, debts and goals": "e fakturennoù, e goustoù, e zleoù hag e balioù",
  "places nearby, routes and their saved spots, on your google maps key": "lec'hioù tost, hentoù ha lec'hioù enrollet, gant ho alc'hwez google maps",
  "gesture drawing and japanese": "tresañ pozioù ha japaneg",
  "the shared doodle wall": "ar voger doodle rannet",
  "their own scan library": "e levraoueg skanadennoù",
  "their pings ring at home, chi answers their voice": "e bingoù a son er gêr, chi a respont d'e vouezh",
  "chi can dm your contacts for them": "chi a c'hell kas DMoù d'ho darempredoù evitoc'h",
  "vps panel and bot controls": "panel vps ha reolennoù ar botoù",
  "every log line": "pep linenn marilh",
  "spend and billing": "kement a gouezh ha fakturennoù",
  "api keys, ssh": "alc'hwezioù api, ssh",
  "this dashboard": "an daolenn-vras-mañ",
  "tap to upload": "stokit evit pellkas",
  "{count} kept": "{count} miret",
  "uploading {n} of {total}": "o pellkas {n} diwar {total}",
  "scan kept": "skanadenn miret",
  "{count} scans kept": "{count} skanadenn miret",
  "upload failed": "c'hwitet eo bet ar pellkas",
  "the brother is scanning": "ar brother a skan",
  "scan failed": "c'hwitet eo bet ar skanadenn",
  "saving {n} of {total}": "o enrollañ {n} diwar {total}",
  "added to scans": "ouzhpennet d'ar skanadennoù",
  "could not save that": "n'eo ket bet posupl enrollañ an dra-se",
  "pdf scan, use download to open it": "skanadenn pdf, implijit pellgargañ evit he digeriñ",
  "delete this scan?": "dilemel ar skanadenn-mañ?",
  "days apart": "deiz a-douez",
  "times a week, any days": "gwech bep sizhun, deiz ebet",
  "day of the month": "deiz ar miz",
  "added by another part of chix, ticked off there too": "ouzhpennet gant ul lodenn all eus chix, tikañ eno ivez",
  "delete {title} and its history?": "dilemel {title} hag e istor?",
  "no routines": "ritual ebet",
  "ChiX routine": "ritual ChiX",
  "time for {title}": "mare evit {title}",
  "weekdays": "devezhioù labour",
  "every {n} days": "bep {n} deiz",
  "{n}x a week": "{n}x bep sizhun",
  "monthly on day {day}": "bep miz d'an deiz {day}",
  "{done}/{times} this week": "{done}/{times} er sizhun-mañ",
  "ping {time}": "ping {time}",
  "{n}w streak": "renk {n} sizhun",
  "{n} streak": "renk {n}",
  "{title} done": "{title} graet",
  "sticky {date}": "pegus {date}",
  "saved {time}": "enrollet {time}",
  "nothing coming up": "netra o tont",
  "edit chix task": "kemmañ an trevell chix",
  "new chix task": "trevell chix nevez",
  "saving...": "o enrollañ...",
  "mark \"{title}\" as done?": "merkañ \"{title}\" evel graet?",
  "urgent": "a-zevri",
  "high": "uhel",
  "medium": "etre",
  "low": "izel",
  "{count} shown, updated {time}": "{count} diskouezet, nevesaet {time}",
  "nothing pending": "netra o c'hortoz",
  "night": "noz",
  "fog": "latar",
  "ember": "glaou",
  "abyss": "doub",
  "petal": "bleunienn",
  "peach": "pesk",
  "mint": "menta",
  "lilac": "lila",
  "starlight": "sterenn",
  "venom": "pozizon",
  "pocket": "godell",
  "{title} reached, tap done to cross it off": "{title} tizhet, stokit war graet evit e dremen",
  "delete {title}? it won't come back": "dilemel {title}? ne zeuio ket en-dro",
  "done · {n}": "graet · {n}",
  "no goals": "pal ebet",
  "this one's done, saving keeps it crossed out": "an hini-mañ zo graet, enrollañ a lez anezhañ treuzet",
  "no goals on the go": "pal ebet o vont war-raok",
  "add a couple of options": "ouzhpennit un nebeut dibaboù",
  "last one standing: {label}": "an hini diwezhañ en e sav: {label}",
  "everything's been knocked out": "pep tra zo bet skubet",
  "spinning": "o treiñ",
  "the wheel says": "ar rod a lavar",
  "new wheel": "rod nevez",
  "knocked out": "skubet",
  "{n} on the wheel, {out} knocked out": "{n} war ar rod, {out} skubet",
  "{n} on the wheel": "{n} war ar rod",
  "just now": "bremañ-vat",
  "{n}m ago": "{n} m 'zo",
  "{n}h ago": "{n} e 'zo",
  "ready": "prest",
  "flick the wheel or press spin": "stlejit ar rod pe wasit war treiñ",
  "add a couple of options to spin": "ouzhpennit un nebeut dibaboù da dreiñ",
  "a wheel holds {max} options": "ur rod a zalc'h {max} dibab",
  "only {room} fit, a wheel holds {max}": "{room} hepken a c'hall tremen, ur rod a zalc'h {max}",
  "my characters": "ma c'harzhoù",
  "there aren't enough characters yet": "n'eus ket a-walc'h a gharzhoù c'hoazh",
  "which oc": "peseurt oc",
  "{name} copy": "eilad {name}",
  "delete the wheel \"{name}\"?": "dilemel ar rod \"{name}\"?",
  "yes or no": "ya pe nann",
  "what to draw": "petra da dresañ",
  "dinner": "koan",
  "dice": "dañs",
  "who does it": "piv a ra",
  "yes": "ya",
  "gesture warm up": "tommadur tresañ",
  "portrait": "poltred",
  "an oc": "un oc",
  "hands and feet": "daouarn ha treid",
  "background": "drekleur",
  "comic page": "pajenn komikoù",
  "redraw an old piece": "adlunia un daolenn gozh",
  "burgers": "burgerioù",
  "noodles": "nouilh",
  "cook something": "kistinañ un dra bennak",
  "yellow": "melen",
  "orange": "orañjez",
  "lime": "limon",
  "teal": "teal",
  "blue": "glas",
  "purple": "more",
  "pink": "pink",
  "white": "gwenn",
  "black": "du",
  "sky": "oabl",
  "slate": "slate",
  "edit message": "kemmañ ar gemennadenn",
  "delete your message? it goes for everyone": "dilemel ho kemennadenn? mont a ra evit an holl",
  "delete {name}'s message? it goes for everyone": "dilemel kemennadenn {name}? mont a ra evit an holl",
  "couldn't delete that": "n'eo ket bet posupl dilemel an dra-se",
  "couldn't post that": "n'eo ket bet posupl embann an dra-se",
  "1 message": "1 kemennadenn",
  "{n} messages": "{n} kemennadenn",
  "someone": "unan bennak",
  "edited": "kemmet",
  "now": "bremañ",
  "{n}m": "{n} m",
  "{n}h": "{n} e",
  "+{n} more": "+{n} ouzhpenn",
  "couldn't switch": "n'eo ket bet posupl cheñch",
  "switch": "cheñch",
  "profile": "profil",
  "that isn't a picture": "n'eo ket ur skeudenn eo an dra-se",
  "picture saved": "skeudenn enrollet",
  "upload picture": "pellkas ur skeudenn",
  "use {name}'s discord picture": "implijout skeudenn discord {name}",
  "remove picture": "dilemel ar skeudenn",
  "owned by": "perc'hennet gant",
  "remove {name} as an owner": "dilemel {name} evel perc'henn",
  "owner removed": "perc'henn dilamet",
  "another discord user id": "ID un implijer discord all",
  "discord user id": "ID implijer discord",
  "add owner": "ouzhpennañ ur perc'henn",
  "they can sign in as {name} now": "gallout a reont kevreañ evel {name} bremañ",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "ur gont discord a zo perc'henn un alter a c'hell kevreañ ha cheñch d'an alter, setu roit kont an alter e-unan amañ",
  "she/her, they/them…": "she/her, they/them…",
  "a line about them": "ul linenn diwar o fenn",
  "pronouns": "pronomoù",
  "about": "diwar-benn",
  "be {name}": "bezañ {name}",
  "{name} is part of {system}": "{name} a zo ezel eus {system}",
  "back to my profile": "distro d'am profil",
  "remove {name}? their notes and chats stay on the server if you add them back": "dilemel {name}? o notennoù ha kaozeadennoù a chomo war ar servijer ma lakait anezho en-dro",
  "no alters yet. add the first one above": "alter ebet c'hoazh. ouzhpennit an hini kentañ a-us",
  "{name} added": "{name} ouzhpennet",
  "size: {size}, change": "ment: {size}, cheñch",
  "small": "bihan",
  "half": "hanter",
  "wide": "ledan",
  "hide": "kuzhat",
  "move earlier": "arveziñ koshoc'h",
  "move later": "arveziñ diwezhatoc'h",
  "hold to drag": "derc'hel evit stlejañ",
  "arrange home": "aozañ ar gêr",
  "ask chi": "goulenn digant chi",
  "inbox": "boest-lizher",
  "gauges": "jaugoù",
  "message board": "taolenn gemennadennoù",
  "spin": "treiñ",
  "{n} lines": "{n} linenn",
  "live": "war-eeun",
  "no shared boards yet. make one and everyone can draw on it together": "taolenn rannet ebet c'hoazh. krouit unan ha pep unan a c'hell tresañ warni asambles",
  "no shared boards yet. Fractal can make one": "taolenn rannet ebet c'hoazh. Fractal a c'hell krouiñ unan",
  "{shared} shared · {mine} yours": "{shared} rannet · {mine} ho re",
  "could not load the boards": "n'eo ket bet posupl kargañ an taolennoù",
  "could not make a board": "n'eo ket bet posupl krouiñ un daolenn",
  "that board was deleted": "an daolenn-se zo bet dilamet",
  "shared board": "taolenn rannet",
  "board": "taolenn",
  "offline, will send when back": "e-maez linenn, a gaso pa vo distro",
  "that's someone else's, only they can change it": "hini unan all eo, ne c'hall kemmañ nemet an hini-se",
  "lost the board": "kollet eo an daolenn",
  "that layer is hidden, show it to draw": "kuzhet eo an dra-se, diskouezit anezhi evit tresañ",
  "that layer is hidden, show it to write": "kuzhet eo an dra-se, diskouezit anezhi evit skrivañ",
  "that layer is locked": "prennet eo an dra-se",
  "that layer is {who}'s, ask them to let you draw on it": "hini {who} eo an dra-se, goulennit outañ ma tilezo ac'hanoc'h da dresañ warni",
  "that layer has other people's lines, use the stroke eraser": "linennoù tud all zo war an dra-se, implijit ar skarell-gwazhioù",
  "pencil found, fingers now move the board": "ar vagenn zo kavet, ar bizied a fiñv an daolenn bremañ",
  "{n} frames": "{n} skeudenn",
  "open": "digor",
  "empty": "goullo",
  "this layer is yours": "ho hini eo an dra-se",
  "{who}'s layer": "treuzenn {who}",
  ", open to everyone": ", digor d'an holl",
  ", only they draw here": ", ne dres nemet ar re-se amañ",
  "frames": "skeudennoù",
  "animate": "bevaat",
  "layer {n}": "treuzenn {n}",
  "delete {name}? you can undo it": "dilemel {name}? gallout a rit disober",
  "{name} cleared, undo brings it back": "{name} skubet, disober a zegas anezhañ en-dro",
  "{n} frames is the most a layer holds": "{n} skeudenn eo ar muiañ a zalc'h ur gwiskad",
  "delete frame {n}? you can undo it": "dilemel skeudenn {n}? gallout a rit disober",
  "frame {n}": "skeudenn {n}",
  "frames per second": "skeudennoù dre eil",
  "onion skin {state}": "krec'hin onion {state}",
  "shared · look only": "rannet · sellout hepken",
  "shared · live": "rannet · war-eeun",
  "private": "prevez",
  "paper {color}": "paper {color}",
  "could not make the picture": "n'eo ket bet posupl krouiñ ar skeudenn",
  "draw something first": "tresit un dra bennak da gentañ",
  "posted to the doodle wall": "embannet war voger an doodle",
  "could not post it": "n'eo ket bet posupl embann",
  "delete {name}? this can't be undone": "dilemel {name}? ne c'haller ket disober",
  "delete {name}? this can't be undone, and it goes for everyone": "dilemel {name}? ne c'haller ket disober, ha mont a ra evit an holl",
  "could not delete it": "n'eo ket bet posupl dilemel",
  "could not open that board": "n'eo ket bet posupl digeriñ an daolenn-se",
  "brush": "broust",
  "erase": "skarañ",
  "select": "diuzañ",
  "shape": "stumm",
  "text": "testenn",
  "move": "fiñval",
  "line": "linenn",
  "arrow": "biz",
  "box": "boest",
  "ellipse": "elipsenn",
  "rub out": "skarañ",
  "whole strokes": "lamennoù a-bezh",
  "duplicate": "eilañ",
  "delete": "dilemel",
  "done": "graet",
  "drag to pick, tap one stroke": "stlejit evit diuzañ, stokit war ul lamenn",
  "show": "diskouez",
  "lock": "prennañ",
  "unlock": "dibrennañ",
  "move up": "sevel",
  "move down": "diskenn",
  "stop playing": "paouez c'hoari",
  "play this layer": "c'hoari an dreuzenn-mañ",
  "previous frame": "skeudenn a-raok",
  "next frame": "skeudenn da-heul",
  "new empty frame": "skeudenn goullo nevez",
  "copy this frame": "eilañ ar skeudenn-mañ",
  "delete this frame": "dilemel ar skeudenn-mañ",
  "move this frame earlier": "lakaat ar skeudenn-mañ a-raok",
  "move this frame later": "lakaat ar skeudenn-mañ war-lerc'h",
  "plain": "simpl",
  "lines": "linennoù",
  "pen": "pennad",
  "pencil": "krayon",
  "ink": "ankr",
  "marker": "merker",
  "glow": "lufr",
  "eraser": "skarell",
  "water": "dour",
  "air": "aer",
  "spray": "spraeañ",
  "coal": "glaou",
  "chalk": "tisa",
  "crayon": "krayon-koar",
  "rainbow": "gwevenn-oabl",
  "glitter": "lufradennoù",
  "neon": "neon",
  "boil": "berwi",
  "wave": "houl",
  "flame": "flamm",
  "march": "marc'h",
  "pulse": "puls",
  "draw": "tresañ",
  "paint": "pentañ",
  "texture": "gwiad",
  "steady": "stabil",
  "pressure": "gwask",
  "soft": "fall",
  "spread": "skignañ",
  "reset this brush": "adlakaat ar broust-mañ",
  "multiply": "liesaat",
  "screen": "skramm",
  "overlay": "gwiskad",
  "soft light": "sklaerder",
  "hard light": "start sklaerder",
  "darken": "teñvalaat",
  "lighten": "sklaeraat",
  "color dodge": "skañvaat liv",
  "color burn": "leskiñ liv",
  "difference": "diforc'h",
  "exclusion": "ezporzh",
  "Goals": "Palioù",
  "me": "me",
  "Profile": "Profil",
  "Message board": "Taolenn gemennadennoù",
  "Roulette": "Roulette",
  "Whiteboards": "Taolennoù gwenn",
  "nothing on the board yet": "netra war an daolenn c'hoazh",
  "add to a": "ouzhpennañ d'un",
  "default": "dre ziouer",
  "out of": "diwar",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "pal ebet c'hoazh. ouzhpennit unan evit ur chaper da echuiñ, ur gwezhiad pajennoù da dizhout pe kement tra a glaskit",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "ar c'hana zo an daolenn gojūon a ra reizh. ar c'hanji zo ar 2 211 kanji jlpt n5 betek n1, ster ha lennadur diwar kanjidic2 (edrdg, cc by-sa 4.0), live diwar roll jlpt Jonathan Waller (cc by)",
  "bring all back": "adlakaat an holl",
  "slices": "tamm",
  "history": "istor",
  "options": "dibaboù",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "pegañ ur roll a ouzhpenn an holl. pizza *3 a ra pizza teir gwech muioc'h tebegus, hag ar pouezioù dindan a laka anezho evit pep tamm",
  "no options yet. add a few, or start from a preset in options": "dibab ebet c'hoazh. ouzhpennit un nebeut, pe krogit diwar ur rakdiuzad e dibaboù",
  "shuffle": "meskañ",
  "even odds": "chañs par",
  "theme colours": "livioù an tem",
  "tally": "jedadenn",
  "last spins": "treiñ diwezhañ",
  "nothing spun on this wheel yet": "netra treiñ war ar rod-mañ c'hoazh",
  "after a spin": "goude un treiñ",
  "keep it": "miret",
  "knock it out": "skarañ",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "skarañ a dennañ pep gounezer diouzh ar rod betek ma lakaot an holl en-dro, mat evit ar c'hrommoù hag ar gevezadegoù",
  "spin length": "pad an treiñ",
  "quick": "buan",
  "clicks and a jingle": "klikoù ha ur jingle",
  "new wheel from": "rod nevez diwar",
  "copy this wheel": "eilañ ar rod-mañ",
  "delete wheel": "dilemel ar rod",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "ar gounezerien zo dibabet gant diouer surentez ho trevnad, e-keñver pouez pep tamm, setu un tamm div wech brasoc'h a zo div wech muioc'h tebegus",
  "wheel": "rod",
  "the wheel, flick it to spin": "ar rod, stlejit evit treiñ",
  "add options, one per line": "ouzhpennit dibaboù, unan dre linenn",
  "option": "dibab",
  "weight": "pouez",
  "less likely": "nebeutoc'h tebegus",
  "more likely": "muioc'h tebegus",
  "less": "nebeutoc'h",
  "more": "muioc'h",
  "shared": "rannet",
  "new board": "taolenn nevez",
  "mine · private": "ma re · prevez",
  "no boards of your own yet. only you ever see these": "n'hoc'h eus taolenn ho unan c'hoazh. c'hwi hepken a wel anezho",
  "layers": "treuzennoù",
  "opacity": "dizirouster",
  "blend": "kendeuzañ",
  "let others draw on this layer": "lezel ar re all da dresañ war an dreuzenn-mañ",
  "brush ·": "broust ·",
  "pick from the board": "dibab diwar an daolenn",
  "recent": "nevez-zo",
  "any colour": "liv ebet",
  "paper": "paper",
  "only the pencil draws, fingers move and zoom the board": "ar grayon hepken a dres, ar bizied a fiñv hag a zoum an daolenn",
  "fit": "ober a-bezh",
  "save png": "enrollañ png",
  "post to doodles": "embann d'an doodles",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "daou viz a besk ha fiñv, stokit gant daou viz evit disober, tri evit adober. war ur c'hlavier: spas a stlej, [ ha ] ment, ⌘z disober, k brouserioù, x a skar lamennoù a-bezh, t testenn, v diuzañ, u stummoù, virgulenn ha pik a ya dre skeudennoù, barrenn dilec'hiañ a c'hoari",
  "delete board": "dilemel an daolenn",
  "Board": "Taolenn",
  "everyone on chi sees this": "an holl war chi a wel an dra-se",
  "nothing on the board yet. post the first line": "netra war an daolenn c'hoazh. embannit ar c'hentañ linenn",
  "who's here": "piv zo amañ",
  "who is here": "piv zo amañ",
  "jot to inbox": "skrivañ er voest-lizher",
  "say something to everyone": "lavarit un dra bennak d'an holl",
  "message for the board": "kemennadenn evit an daolenn",
  "finish the chapter 2 sprites…": "echuiñ sprites chaper 2…",
  "why, or what done looks like, optional": "perak, pe penaos e vo graet, diret",
  "progress": "araokadur",
  "counting what": "kontañ petra",
  "a board everyone can draw on together": "un daolenn ma c'hall an holl tresañ warni asambles",
  "a board only you can see": "un daolenn ma'z oc'h hepken o welet",
  "text on the board": "testenn war an daolenn",
  "back to the boards": "distro d'an taolennoù",
  "undo, or tap with two fingers": "disober, pe stokit gant daou viz",
  "redo": "adober",
  "redo, or tap with three fingers": "adober, pe stokit gant tri biz",
  "fit the drawing on screen": "ober a-bezh an tresadenn war ar skramm",
  "fit to the drawing": "ober a-bezh an tresadenn",
  "board settings": "arventennoù an daolenn",
  "brush size": "ment ar broust",
  "say something to everyone…": "lavarit un dra bennak d'an holl…",
  "new alter name": "anv an alter nevez",
  "all {count} presets are taken, unpin one first": "an holl {count} rakdiuzad zo kemeret, dibennit unan da gentañ",
  "could not change the owner": "n'eo ket bet posupl cheñch ar perc'henn",
  "description": "diskrivadur",
  "groups": "strolladoù",
  "large": "bras",
  "layout": "aozadur",
  "mine {n}": "ma re {n}",
  "owners": "perc'hennoù",
  "presets": "rakdiuzadoù",
  "reversed": "a-gin",
  "sort by": "rummañ dre",
  "tap the star on a key to pin it. pins sit above the dock as presets": "stokit war ar steredenn war un alc'hwez evit he fennañ. ar re pennet a chom a-us d'an doc'h evel rakdiuzadoù",
  "unknown date": "deiziad dianav",
  "{name} is not yours any more": "n'eo ket {name} ho hini ken",
  "{name} is yours now": "{name} zo ho hini bremañ",
  "Grid": "Gwriziennoù",
  "Masonry": "Maen-maen",
  "Rows": "Renkoù",
  "Big grid": "Gwriziennoù bras",
  "Wall": "Moger",
  "Posts": "Embannadennoù",
  "Shuffle": "Meskañ",
  "random order, rolled once while it is open": "urzh dre zegouezh, teuliet ur wech keit ha ma'z eo digor",
  "Newest": "Nevesañ",
  "latest saved first": "an hini enrollet diwezhañ da gentañ",
  "Oldest": "Kozhañ",
  "earliest saved first": "an hini enrollet kentañ da gentañ",
  "Most tagged": "Tagaet ar muiañ",
  "refs with the most tags first": "ar refoù gant ar muiañ a dagoù da gentañ",
  "Undescribed first": "Hep diskrivadur da gentañ",
  "what has no description yet comes first": "ar pezh n'en deus diskrivadur ebet c'hoazh a zeu da gentañ",
  "By tag": "Dre dag",
  "grouped under the most used tag": "strollet dindan an tag implijet ar muiañ",
  "By author": "Dre aozer",
  "grouped A to Z": "strollet A betek Z",
  "By month": "Dre viz",
  "grouped by the month you saved them": "strollet dre viz enrollañ",
  "By type": "Dre seurt",
  "stills, gifs and clips apart": "skeudennoù, gifoù ha klipoù a-ziforc'h",
  "sign in with discord · fractal and pauline": "kevreañ gant discord · fractal ha pauline",
  "continue with discord": "kenderc'hel gant discord",
  "use": "implijout",
  "Ready when you are.": "Prest on pa vo mat ganeoc'h.",
  "unit": "unanenn",
  "chi · online": "chi · enlinenn",
  "clear": "skarañ",
  "tip of the day": "tun an deiz",
  "another one": "unan all",
  "add to a budget": "ouzhpennañ d'ur budjed",
  "every month": "bep miz",
  "up next": "da-heul",
  "all tasks": "an holl drevelloù",
  "nothing due, go draw": "netra da ober, a-benn tresañ",
  "routines": "ritualoù",
  "routines done for today": "ritualoù hiziv graet",
  "notes": "notennoù",
  "no notes yet": "notenn ebet c'hoazh",
  "Tasks": "Trevelloù",
  "chix task": "trevell chix",
  "Notes": "Notennoù",
  "note": "notenn",
  "scratchpad": "skrivlevr",
  "edit": "kemmañ",
  "view": "gwelet",
  "random": "dre zegouezh",
  "newest": "nevesañ",
  "oldest": "kozhañ",
  "by tag": "dre dag",
  "stills": "skeudennoù",
  "moving": "o fiñval",
  "chi's description": "diskrivadur chi",
  "your note": "ho notenn",
  "ctrl+enter saves and goes next": "ctrl+enter a enrol hag a ya d'ar c'hentañ",
  "edit tags": "kemmañ an tagoù",
  "close": "serriñ",
  "next": "da-heul",
  "Chi online. What are we drawing?": "Chi enlinenn. Petra a dresimp?",
  "what should I work on?": "petra a rafen?",
  "pose refs": "refoù poz",
  "pick an oc": "dibabit un oc",
  "comms": "comms",
  "Routines": "Ritualoù",
  "routine": "ritual",
  "every day": "bemdez",
  "on these days": "d'an devezhioù-se",
  "every few days": "bep un nebeut deiz",
  "times a week": "gwech bep sizhun",
  "once a month": "gwech bep miz",
  "mon": "lun",
  "tue": "meu",
  "wed": "mer",
  "thu": "yaou",
  "fri": "gwe",
  "sat": "sad",
  "sun": "sul",
  "ping at": "ping da",
  "paused": "ehanet",
  "cancel": "nullañ",
  "nothing on today": "netra hiziv",
  "other days": "deizioù all",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "ritual ebet c'hoazh. ouzhpennit unan evit ur skeudenn bemdez, ur stream sizhuniek pe kement tra a fell deoc'h derc'hel",
  "Pings": "Pingoù",
  "reminder": "kemennadenn",
  "alarm": "alarm",
  "timer": "minutenner",
  "once": "ur wech",
  "daily": "bemdez",
  "weekly": "bep sizhun",
  "set": "lakaat",
  "no pings yet. set one for a stream, a deadline or a break": "ping ebet c'hoazh. lakait unan evit ur stream, un termen pe un ehan",
  "Session": "Estez",
  "focus": "fokus",
  "start": "krogañ",
  "tap the time to type your own, like 40 or 1h30": "stokit war an eur evit skrivañ hini hoc'h unan, evel 40 pe 1h30",
  "0 blocks today": "0 bloc'h hiziv",
  "Palette": "Palette",
  "keep": "derc'hel",
  "tap a swatch to copy it, hold to toss it": "stokit war ul liv evit e eilañ, derc'hel evit e deuler",
  "save prompt": "enrollañ ar prompt",
  "tap a card to copy the whole prompt": "stokit war ur gartenn evit eilañ ar prompt a-bezh",
  "Comms": "Comms",
  "tap a commission to edit it": "stokit war un urzh evit e gemmañ",
  "list": "roll",
  "money": "arc'hant",
  "new commission": "urzh nevez",
  "sketch": "krouiz",
  "wip": "wip",
  "review": "adwel",
  "reference pics": "skeudennoù ref",
  "this month": "er miz-mañ",
  "this year": "er bloaz-mañ",
  "to be paid": "da baeañ",
  "paid by month": "paeet dre viz",
  "by client": "dre bleg",
  "by status": "dre statud",
  "a commission counts on the day it was marked paid. change that day on its card": "un urzh a gont d'an deiz m'eo bet merket evel paeet. cheñchit an deiz-se war e gartenn",
  "Budget": "Budjed",
  "left": "chom",
  "in and out": "ebarzh hag er-maez",
  "monthly by category": "bep miz dre rummad",
  "debts and goals": "dleoù ha palioù",
  "one off": "un taol hepken",
  "monthly": "bep miz",
  "bills": "fakturennoù",
  "costs": "koustoù",
  "debts": "dleoù",
  "goals": "palioù",
  "nothing here yet. add a bill, a debt or a goal above": "netra amañ c'hoazh. ouzhpennit ur fakturenn, un dle pe ur pal a-us",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "c'hwi hepken a wel an dra-se nemet ma lakait da unan bennak e rannañ. an urzhioù paeet a gont evel arc'hant o tont",
  "Gesture": "Poz",
  "timed poses, draw fast, the next one drops in on its own": "pozioù amzeret, tresit buan, an hini da-heul a zeu e-unan",
  "source": "tarzh",
  "full body": "korf-a-bezh",
  "my refs": "ma refoù",
  "each pose": "pep poz",
  "pause": "ehan",
  "skip": "lammat",
  "Japanese": "Japaneg",
  "learning": "o teskiñ",
  "show answer": "diskouez ar respont",
  "again": "en-dro",
  "hard": "start",
  "good": "mat",
  "easy": "aes",
  "space shows the answer, 1 to 4 grades it": "ar spas a ziskouez ar respont, 1 da 4 a notenn",
  "decks": "pakadoù",
  "new cards a day": "kartennoù nevez bemdez",
  "study, new cards come in this order": "studiañ, ar c'hartennoù nevez a zeu en urzh-mañ",
  "Characters": "Karzhoù",
  "chi look": "chi sell",
  "no characters match": "karzh ebet ne glot",
  "new character": "karzh nevez",
  "name": "anv",
  "tags, comma separated": "tagoù, dispartiet dre virgulennoù",
  "sheet picture": "skeudenn ar follenn",
  "character file": "restr ar c'harzh",
  "chi saw": "chi he deus gwelet",
  "use as picture": "implijout evel skeudenn",
  "add pic": "ouzhpennañ ur skeudenn",
  "drop pic": "lakaat ur skeudenn",
  "merge": "kenunaniñ",
  "merge into": "kenunaniñ e",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "dibabit ar memes karzh dindan un anv all. e skeudennoù hag ar pezh a vank d'ar follenn-mañ a ya amañ, hag an enporzhioù a nevesaio ar follenn-mañ adalek bremañ.",
  "Calendar": "Deiziadur",
  "Maps": "Kartennoù",
  "near me": "tost din",
  "maps needs a google key": "kartennoù en deus ezhomm eus un alc'hwez google",
  "in console.cloud.google.com make a project and turn on billing": "e console.cloud.google.com krouit ur raktres hag enaouit ar fakturadur",
  "turn on": "enaouiñ",
  "and": "ha",
  "make an api key under credentials, and limit it to those three apis": "krouit un alc'hwez api dindan titouroù-anavezout, ha bevennit anezhañ d'an teir api-se",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "pegit anezhañ en arventennoù, alc'hwezioù, google maps. pe lakait anezhañ war ar servijer evel GOOGLE_MAPS_API_KEY",
  "open setup": "digeriñ an arventennoù",
  "search this area": "klask en takad-mañ",
  "route here": "hent amañ",
  "route from": "hent diouzh",
  "remove": "lemel",
  "nearby": "tost",
  "route": "hent",
  "best rated": "ar gwellañ notennet",
  "most reviews": "ar muiañ a sellou",
  "closest": "tostañ",
  "parking first": "parklec'h da gentañ",
  "add where you start and where you're going. places from nearby can go in with their route button": "ouzhpennit al lec'h ma krogit hag a-hed ma'z it. al lec'hioù tost a c'hell mont ebarzh gant o bouton hent",
  "from here": "diouzh amañ",
  "home": "ti",
  "best order for the middle stops": "an urzh gwellañ evit ar chomoù e-kreiz",
  "plan route": "aozañ an hent",
  "time": "amzer",
  "distance": "pellder",
  "stops": "chomoù",
  "pins": "pinoù",
  "tap drop a pin, then tap the map where it goes": "stokit war lakaat ur pin, goude war ar gartenn el lec'h ma rank mont",
  "pin where i am": "pinañ el lec'h ma'z on",
  "places": "lec'hioù",
  "star a place from nearby to keep it here": "lakait ur steredenn war ul lec'h tost evit e virout amañ",
  "routes": "hentoù",
  "plan a route and save it to keep it here": "aozit un hent hag enrollit anezhañ evit e virout amañ",
  "only you see these unless you switch places and routes on for someone in sharing": "c'hwi hepken a wel an dra-se nemet ma lakait al lec'hioù hag an hentoù da unan bennak e rannañ",
  "tape": "teip",
  "Scans": "Skanadennoù",
  "photo": "foto",
  "scan": "skanañ",
  "on this pc": "war ar PC-mañ",
  "upload all": "pellkas an holl",
  "scans the brother left in the inbox folder that the web cannot see yet": "skanadennoù ar brother lezet er c'havlec'h boest-lizher na c'hall ket ar web gwelet c'hoazh",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "skanadenn ebet c'hoazh. skanit war ar PC, pe kemerit ur foto eus ur skeudenn",
  "Doodles": "Doodles",
  "paste": "pegañ",
  "no doodles yet. paste one, or add pictures from your phone": "doodle ebet c'hoazh. pegit unan, pe ouzhpennit skeudennoù eus ho pellgomzer",
  "doodle": "doodle",
  "title": "titl",
  "drawn by": "tresañ gant",
  "day": "deiz",
  "characters in it": "karzhoù ebarzh",
  "undo mine": "disober ma re",
  "newer": "nevesoc'h",
  "older": "koshoc'h",
  "Server": "Servijer",
  "reload caddy": "adkargañ caddy",
  "memory": "memor",
  "load": "karg",
  "bots up": "botoù war-wel",
  "Logs": "Marilhoù",
  "nothing happened yet, it shows up here live": "netra c'hoarvezet c'hoazh, e teuio war-wel amañ war-eeun",
  "billing": "fakturadur",
  "month": "miz",
  "tags": "tagoù",
  "key": "alc'hwez",
  "tagging": "tagañ",
  "budget": "budjed",
  "batch": "pakad",
  "by model": "dre skouer",
  "by person": "dre zen",
  "estimates from the token counts claude sends back. billing has the real bill": "priziadennoù diwar niver an tokenoù a gas claude en-dro. ar fakturadur en deus ar fakturenn wir",
  "People": "Tud",
  "let in": "lezel da vont ebarzh",
  "their chi": "o chi",
  "yours": "ho re",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "an holl a gomz ouzh chi war ho alc'hwez claude. morse ne wellont anezhi, o c'haozeadennoù hag o memor a chom d'e-unan, hag o lodenn eus ar fakturenn a zo jedet amañ",
  "let someone in": "lezel unan bennak da vont ebarzh",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "kevreañ a reont gant discord. ma klaskont a-raok ma'z ouzhpennit anezho, ar bajenn a ziskouez dezho o ID da gas deoc'h",
  "only you": "c'hwi hepken",
  "Sharing": "Rannañ",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "dibabit petra a c'hall pep hini gwelet. lenn hepken a c'hallont, morse cheñch. diskouezet eo e-kichen o notennoù, pingoù hag ar rest, hag o chi a c'hell o lenn ivez",
  "shared with you": "rannet ganeoc'h",
  "nobody shares anything with you yet": "den ne rann netra ganeoc'h c'hoazh",
  "Setup": "Arventennoù",
  "assistant": "skoazeller",
  "anthropic api key": "alc'hwez api anthropic",
  "chat model": "model kaozeal",
  "ref tagging model": "model tagañ ref",
  "monthly tagging budget, usd": "budjed tagañ miziek, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "an tagañ a ehan pa ya priziadenn ar miz dreist ar budjed. 0 a dalv bevenn ebet. claude-haiku-4-5 a dag war-raok pris",
  "currency": "moneiz",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "ho re hepken. ar sin diskouezet war comms, stadegoù arc'hant ha budjed. auto a lenn anezhañ diouzh ar pezh a skrivit war an urzhioù. enrollet eo kerkent ha ma tibabit",
  "log into the plane tab, then connect": "kevreit ouzh an ivinell plane, goude kevreit",
  "open plane, make an api token in profile settings, paste it here": "digerit plane, krouit ur jedon api en arventennoù ar profil, pegit anezhañ amañ",
  "connect plane": "kevreañ plane",
  "workspace slug": "slug ar spas labour",
  "api key": "alc'hwez api",
  "load boards": "kargañ an taolennoù",
  "chix bot": "chix bot",
  "api url": "url an api",
  "your discord user id": "ho ID implijer discord",
  "browser key, optional": "alc'hwez merdeer, diret",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "an alc'hwez api a glask lec'hioù hag a aoz hentoù diouzh ar servijer. ar gartenn a gargañ gant an alc'hwez merdeer m'eus unan, a-hend-all gant an alc'hwez api. GOOGLE_MAPS_API_KEY war ar servijer a drec'h war hemañ",
  "server": "servijer",
  "bots folder": "teuliad ar botoù",
  "sudo password": "ger-tremen sudo",
  "ssh host": "ostiz ssh",
  "ssh user": "implijer ssh",
  "ssh key file": "restr alc'hwez ssh",
  "browser extension": "astenn merdeer",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "pegit an dra-se en arventennoù an astenn evel jedon ar c'houmoul. ho hini eo, setu ar pezh a enrollit a zeu evel ac'hanoc'h",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome: dizip war an teuliad kozh ha pouezit war reload e chrome://extensions. firefox: digerit ar restr e firefox ha aotreit anezhi, e-unan e nevesa goude",
  "your extension token": "ho jedon astenn",
  "copy": "eilañ",
  "new token": "jedon nevez",
  "links": "liammoù",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "unan dre linenn evel anv | url. digeriñ a reont e-barzh arload ar burev, pe en ur ivinell nevez war ar web",
  "desk": "burev",
  "cloud url": "url ar c'houmoul",
  "cloud token": "jedon ar c'houmoul",
  "chrome extension token": "jedon astenn chrome",
  "brother scan folder": "teuliad skanañ ar brother",
  "start with windows": "loc'hañ gant windows",
  "security": "surentez",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "dilugañ a ra an holl bellgomzerioù, taolennoù ha merdeerioù kevreet, an hini-mañ en o zouez. implijit anezhañ ma'z eo bet kollet un trevnad pe ma kredit ez eo bet unan bennak ebarzh",
  "log out everywhere": "dilugañ e pep lec'h",
  "pick a look": "dibabit un neuz",
  "background pattern": "patrom drekleur",
  "film grain and fog": "greun film ha latar",
  "calm motion": "fiñv sioul",
  "retry": "esaeañ en-dro",
  "toss": "teuler",
  "logs": "marilhoù",
  "paid on": "paeet d'an",
  "undo": "disober",
  "setup token": "jedon arventenn",
  "talk to chi": "komz ouzh chi",
  "jot into inbox": "skrivañ er voest-lizher",
  "whose budget": "budjed piv",
  "what kind": "peseurt seurt",
  "what it is": "petra eo",
  "ask chi…": "goulenn digant chi…",
  "ask": "goulenn",
  "refresh": "freskaat",
  "find a task": "kavout un trevell",
  "just type, it saves itself": "skrivit, enrollet eo e-unan",
  "search notes": "klask notennoù",
  "back": "distro",
  "print": "moullañ",
  "# heading\n\nmarkdown works, autosave is on": "# titl\n\nmod markdown a laka da labourat, enrolladur emgefre zo enaouet",
  "search refs, tags, characters": "klask refoù, tagoù, karzhoù",
  "tile size": "ment ar mean-tailh",
  "add pictures": "ouzhpennañ skeudennoù",
  "sort the feed": "rummañ ar feed",
  "what you want to remember about this": "ar pezh a fell deoc'h derc'hel soñj diwar e benn",
  "re-index": "adlakaat meneger",
  "open post": "digeriñ an embannadenn",
  "message chi": "kemennadenn da chi",
  "send": "kas",
  "a sketch a day…": "ur skeudenn bemdez…",
  "how often": "pegement a wech",
  "how many": "pet",
  "note, optional": "notenn, diret",
  "nudge me about…": "lakait ac'hanon e soñj eus…",
  "kind": "seurt",
  "set the time": "lakaat an eur",
  "minutes, like 40 or 1h30": "munutennoù, evel 40 pe 1h30",
  "reset": "adlakaat",
  "another tip": "un tun all",
  "pick a colour": "dibabit ul liv",
  "name, like sitting nsfw": "anv, evel azezañ nsfw",
  "piece": "pezh",
  "client (for the money stats)": "kliant (evit ar stadegoù arc'hant)",
  "amount": "moned",
  "due": "d'ar",
  "what they want drawn": "ar pezh a fell dezho da dresañ",
  "previous month": "miz a-raok",
  "next month": "miz da-heul",
  "what is it": "petra eo",
  "owed": "dleet",
  "category": "rummad",
  "only refs matching… (optional)": "ar refoù o klotañ hepken… (diret)",
  "add the characters from zirk.eu/oc": "ouzhpennañ ar c'harzhoù eus zirk.eu/oc",
  "add the characters from the discord character channel": "ouzhpennañ ar c'harzhoù eus kanol karzhoù discord",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi a sell ouzh skeudennoù karzhoù hag a skriv tagoù hag ul linenn diwar o fenn, evit ma tibabo gwelloc'h karzhoù ha refoù",
  "search name, race, likes, fetishes…": "klask anv, ethnek, a blij dezhañ, fetishoù…",
  "search characters…": "klask karzhoù…",
  "reload": "adkargañ",
  "add an event": "ouzhpennañ un darvoud",
  "map": "kartenn",
  "name it: studio, mum's, good parking": "envel anezhi: stal, ti mamm, parklec'h mat",
  "a note, optional": "notenn, diret",
  "colour": "liv",
  "sushi, art supplies, an address": "sushi, danvez tresañ, ur chomlec'h",
  "how far": "pegement a bellder",
  "add a stop: address, postcode or place": "ouzhpennañ ur chom: chomlec'h, kod-post pe lec'h",
  "add stop": "ouzhpennañ ur chom",
  "download": "pellgargañ",
  "add the picture on your clipboard, or press ctrl+v": "ouzhpennit ar skeudenn eus ho kolver-glip, pe pouezit war ctrl+v",
  "search title, artist, character, tag…": "klask titl, arzour, karzh, tag…",
  "untitled": "hep titl",
  "type a name to add a character": "skrivit un anv evit ouzhpennañ ur c'harzh",
  "count a fap": "kontañ ur fap",
  "console.anthropic.com, api keys": "console.anthropic.com, alc'hwezioù api",
  "the part after the domain": "ar rann a-c'houde an domani",
  "maps javascript, places (new) and routes": "maps javascript, places (new) ha routes",
  "only if the map should load with its own key": "nemet ma tlefe ar gartenn kargañ gant he alc'hwez dezhi",
  "find a tool or place": "kavout ur binvi pe ul lec'h",
  "what needs doing?": "petra zo da ober?",
  "optional notes": "notennoù diret",
  "index": "meneger",
  "mark done": "merkañ evel graet",
  "status": "statud",
  "link a task": "liammañ un trevell",
  "find a plane or chix task": "kavout un trevell plane pe chix",
  "take back the last one": "distreiñ an hini diwezhañ",
  "take out": "tennañ",
  "tasks": "trevelloù",
  "Today": "Hiziv",
  "References": "Arouezioù",
  "describe": "diskrivañ",
  "Ask ChiX": "Goulenn digant ChiX",
  "gesture": "poz",
  "Gesture drawing": "Tresañ pozioù",
  "Session timer": "Minutenner estez",
  "palette": "palette",
  "Commissions": "Urzhioù",
  "maps": "kartennoù",
  "Calculator": "Jedoural",
  "doodles": "doodles",
  "scans": "skanadennoù",
  "Claude usage": "Implij Claude",
  "people": "tud",
  "share": "rannañ",
  "setup": "arventennoù",
  "keys": "alc'hwezioù",
  "themes": "temoù",
  "studio": "studio",
  "system": "reizhiad",
  "Home": "Degemer",
  "Studio": "Studio",
  "Practice": "Pleustr",
  "Ledger": "Levr-kontoù",
  "Library": "Levraoueg",
  "Core": "Kalon",
  "language": "yezh",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "ho re hepken. geriennoù an arload ha respontoù chi a heul anezhi. enrollet eo kerkent ha ma tibabit",
  "Quick note": "Notenn herrek",
  "Reminders": "Kemennadennoù",
  "Ubuntu helpers": "Skoazelloù Ubuntu",
  "Quit": "Kuitaat",
  "open {name}": "digeriñ {name}",
  "sort": "rummañ",
  "this one is mine": "ma hini eo",
  "reverse the order": "dindan-c'houzañ an urzh",
  "filter": "sil",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} a c'hell kevreañ bremañ. krogañ a ra gant chi, notennoù, pingoù, ritualoù ha palioù",
  "retro": "retro",
  "pin": "pennañ",
  "no": "nann",
  "fps": "fps",
  "drama": "dramm",
  "Refs": "Refoù",
  "info": "titouroù",
  "refs": "refoù",
  "feed": "feed",
};
